import { FormInput, Modal, PrimaryButton, copyTextToClipboard } from '@systemeio/ui'
import React, { useEffect, useState } from 'react'
import FormTextarea from 'shared/components/form-textarea'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { FunnelStepId } from '../../../types/funnel-step-interface'
import { getScriptLinkHtmlCode } from '../../../utils/remote-form-utils'

interface CreateRemotePopupLinkModalProps {
  opened: boolean
  onClose: () => void
  domainName: string
  pageHash: string
  funnelStepId: FunnelStepId
}

const CreateRemotePopupLinkModal = ({
  opened,
  onClose,
  domainName,
  pageHash,
  funnelStepId,
}: CreateRemotePopupLinkModalProps) => {
  const { t } = useLocoTranslation()
  const defaultAnchorName = t('dashboard.funnel.configuration.remote.anchor_name_placeholder')
  const [tempAnchorName, setTempAnchorName] = useState(defaultAnchorName)
  const [tempLink, setTempLink] = useState(
    getScriptLinkHtmlCode(domainName, pageHash, funnelStepId, tempAnchorName),
  )

  useEffect(() => {
    setTempLink(getScriptLinkHtmlCode(domainName, pageHash, funnelStepId, tempAnchorName))
  }, [tempAnchorName])

  return (
    <Modal
      opened={opened}
      onClose={() => {
        onClose()
        setTempAnchorName(defaultAnchorName)
      }}
      title={t('dashboard.funnel.configuration.remote.modal_link_header')}
    >
      <form className="flex flex-col gap-6 lg:gap-10">
        <FormInput
          label={t('dashboard.funnel.configuration.remote.anchor')}
          value={tempAnchorName}
          onChange={e => setTempAnchorName(e.target.value)}
        />
        <div className="flex flex-col justify-center gap-3">
          <FormTextarea value={tempLink} disabled />
        </div>
        <div className="flex justify-center gap-4">
          <PrimaryButton
            onClick={async (e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault()
              await copyTextToClipboard(tempLink, t('global.copy_clipboard'))
            }}
          >
            {t('global.copy_to_clipboard_caption')}
          </PrimaryButton>
        </div>
      </form>
    </Modal>
  )
}

export default CreateRemotePopupLinkModal
